import * as yup from 'yup'
import { ProcessingTimeFormProfile } from './processing-time-form.profile'

export const schema = (): yup.ObjectSchema<ProcessingTimeFormProfile> =>
  yup.object({
    processingTime: yup.number().label('Processing Time').min(1).max(5).required(),
  })
